exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".applied-filter-label {\n  display: inline-block;\n  background-color: #0078a5;\n  color: #ffffff;\n  font-weight: bold;\n  border-radius: 10px;\n  padding: 2px 6px;\n  margin: 0 2px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  max-width: 100%; }\n\n.applied-filter-box {\n  padding: 5px 3px;\n  border: 1px solid #aeaeae;\n  background-color: #ffffff; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/edi/angular/app/modules/mobile/components/applied-filters/m-applied-filters.component.scss
// module id = ../../../../../angular/app/modules/mobile/components/applied-filters/m-applied-filters.component.scss
// module chunks = main